// extracted by mini-css-extract-plugin
export default {"container":"ContactInput_container__Wcruh","label":"ContactInput_label__V3Qdx","input":"ContactInput_input__zfsgp"};